import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'
import { type PropsWithChildren } from 'react'
import { useToggle } from 'usehooks-ts'

import { useTriggerEvent } from 'hooks/useTriggerEvent'
import i18n from 'services/i18n'

import { TableModal } from './TableModal'

export const Table = ({
  children,
  isPreviewDisabled = false,
  isPreviewHidden = false,
  messageId,
}: PropsWithChildren<{ isPreviewDisabled?: boolean, isPreviewHidden?: boolean, messageId?: string }>) => {
  const triggerEvent = useTriggerEvent()

  const [isTableOpen, toggleIsTableOpen] = useToggle(false)

  const handleTablePreviewToggle = () => {
    toggleIsTableOpen()
    triggerEvent({
      name: 'kai_conversation_table_opened',
      properties: {
        messageId,
      },
    })
  }

  return (
    <>
      <TableModal
        isTableOpen={isTableOpen}
        onTablePreviewToggle={handleTablePreviewToggle}
      >
        <div className="modal-table my-4">
          <table>{children}</table>
        </div>
      </TableModal>
      <div className="relative flex flex-col gap-y-4 py-4">
        <div className="relative max-h-96 overflow-auto">
          <table>{children}</table>

        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-bg-default to-transparent print:hidden" />

      </div>
      {!isPreviewHidden && (
        <div className="mb-4 mt-1 flex w-full justify-end print:hidden">
          <Button
            type="button"
            isSmall
            onClick={handleTablePreviewToggle}
            disabled={isPreviewDisabled}
            icon={faArrowUpRightAndArrowDownLeftFromCenter}
          >
            {i18n.t('conversation.table_view.open_button')}
          </Button>
        </div>
      )}
    </>
  )
}
